// A monkey, modelled facing +X: a small brown body, a pale face, limbs and a
// long curling tail. Ported 1:1 from age-of-mcp's classic monkey.ts, restoring
// its body/head core, the limb loop and the curling-tail blobs.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#6e4e30",
      position: [0, 0.05, 0], scale: [1, 1.2, 0.9] },               // body
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#7a5836",
      position: [0.012, 0.092, 0] },                                 // head
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#d8bc94",
      position: [0.026, 0.09, 0], scale: [0.7, 1, 1] },             // pale face
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#5e4026",
      position: [0.008, 0.108, 0.018] },                            // ear
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#5e4026",
      position: [0.008, 0.108, -0.018] },
  ];
  // Limbs.
  for (const [x, z] of [[0.02, 0.026], [0.02, -0.026], [-0.02, 0.026], [-0.02, -0.026]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.05, 4),
      color: "#5e4026", position: [x!, 0.025, z!] });
  }
  // Long curling tail — three blobs arcing back and up.
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.009, 0), color: "#6e4e30", position: [-0.035, 0.05, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#6e4e30", position: [-0.055, 0.072, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.007, 0), color: "#6e4e30", position: [-0.05, 0.098, 0] },
  );
  return parts;
}

export const monkey = defineModel({
  id: "monkey",
  scale: 2.39, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Monkey",
  tags: ["creature","monkey","low-poly","age-of-mcp","classic"],
  summary: "Low-poly monkey.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
